const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: "lista",
	lista: [],
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case "PLATAFORMA_MERCADO_LIVRE_MODO_TELA":
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro,
			};

		case "PLATAFORMA_MERCADO_LIVRE_SET_AGUARDANDO":
			return { ...state, aguardando: action.payload };

		case "PLATAFORMA_MERCADO_LIVRE_FILTRO":
			return { ...state, filtro: action.payload };

		case "PLATAFORMA_MERCADO_LIVRE_LISTADO":
			return {
				...state,
				lista: action.payload.data,
			};

		default:
			return state;
	}
};
